import * as THREE from "three";

export let threeFonts = [];
let fontsDisp = [];

export function getThreeFonts(vue) {
    return loadAllFonts(vue).then(() => {
        return fontsDisp;
    });
}

function loadAllFonts(vue) {
    return vue.$request.post("/textGlyphs/getFonts", {}).then(res => {
        fontsDisp = res.obj;
        for (let i = 0; i < fontsDisp.length; i++) {
            let str = fontsDisp[i].baseData;
            // console.log(str);
            threeFonts[fontsDisp[i].fontName] = new THREE.Font(JSON.parse(str));
        }
    });
}

// 加载缺失的glyphs
export function loadFontGlyphs(vue, fontName, chars) {
    // console.log(threeFonts, fontName, chars);
    let glyphs = threeFonts[fontName].data.glyphs;
    let left_chars = "";
    for (let i = 0; i < chars.length; i++) {
        let ch = chars.charAt(i);
        if (!(ch in glyphs)) {
            left_chars += ch;
        }
    }

    if (left_chars.length > 0) {
        return vue.$request.post("/textGlyphs/getTextGlyphs", {
            text: left_chars,
            font: fontName
        }).then(res => {
            let newGlyphs = res.obj;
            for (let ch in newGlyphs) {
                glyphs[ch] = newGlyphs[ch];
            }
        });
    } else {
        return Promise.resolve();
    }
}




// WEBPACK FOOTER //
// ./src/3dapps/js/fontManage.js